import MileageBlock from "./MileageBlock";

export type { MileageBlockProps } from "./MileageBlock";
export default MileageBlock;
